import styled, { css } from "styled-components";
import { device } from "../../constants";

export const Section = styled.section`
  background: #000104;
  position: relative;
  overflow: hidden;
`;

export const Container = styled.div`
  position: relative;
  z-index: 1;

  .start-chat-wrapper {
    margin-top: 40px;
    
    & > a {
      margin-inline: auto;
    }
  }

  @media ${device.laptop} {
    .start-chat-wrapper {
      & > a {
        margin-inline: unset;
      }
    }
  }
`;

export const HighlightBar = styled.div`
  margin: 0 auto;

  width: 32px;
  border: 2px solid ${({ theme }) => theme.colors["vivid-02"]};
  border-radius: 2px;
  
  @media ${device.laptop} {
    width: 48px;
    margin: 0;
  }
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 24px;
  text-align: center;
  line-height: 32px;
  color: ${({ theme }) => theme.colors["neutral-01"]};
  margin-top: 16px;
  margin-inline: auto;
  max-width: 260px;
  
  @media ${device.laptop} {
    text-align: left;
    line-height: 48px;
    font-size: 32px;
    margin-top: 24px;
    margin-inline: unset;
    max-width: unset;
  }
`;

export const Text = styled.div`
  max-width: 635px;
  margin-top: 16px;
  margin-inline: auto;

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    
    color: ${({ theme }) => theme.colors["neutral-01"]};
    text-align: center;
  }

  @media ${device.laptop} {
    text-align: left;
    margin-inline: unset;
    
    p {
      text-align: left;
      font-size: 20px;
      line-height: 36px;
    }
  }
`;

export const BannerImgWrapper = styled.div`
  position: absolute;
  left: 0px;
  width: 100vw;
  
  img {
    max-width: 450px;
    margin: 0 auto;
    display: block;
  }

  @media ${device.laptop} {
    left: unset;
    width: auto;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 0;
    
    img {
      max-width: unset;
    }
  }
`;

export const BannerImg = styled.img`
  width: 100vw;

  @media ${device.laptop} {
    width: auto;
  }
`;

export const LocationsWrapper = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 300px;
  
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  @media ${device.laptop} {
    margin-top: 56px;
  }

  @media ${device.laptopM} {
    flex-direction: row;
    margin-top: 56px;
    gap: 0;
  }
`;

export const LocationsText = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors["neutral-01"]};
  flex: 1;
  text-align: center;
  width: 100%;
  font-size: 18px;
  line-height: 32px;
  
  @media ${device.laptop} {
    font-size: 20px;
    line-height: 32px;
    width: fit-content;
    text-align: left;
  }
`;

export const LocationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
  
  @media ${device.laptop} {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 68px;
    margin-top: 16px;
  }

  @media ${device.laptopL} {
    margin-top: 0;
    justify-content: flex-end;
  }
`;

export const Location = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 8px;

  @media ${device.laptop} {    
    & + & {
      padding-left: 68px;
      
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 64px;
        background: ${({ theme }) => theme.colors["neutral-03"]};
      }
    }
  }
`;

export const Flag = styled.img`
  width: 24px;
  height: 24px;
`;

export const LocationTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 1.4px;
  color: ${({ theme }) => theme.colors["neutral-01"]};
`;

export const LocationPhone = styled.a`
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.4px;
  color: ${({ theme }) => theme.colors["neutral-02"]};
  text-decoration: none;
`;
